import { Component, OnInit} from '@angular/core';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogConfig as MatDialogConfig,
} from '@angular/material/legacy-dialog';

import { Router } from '@angular/router';
import { checkInvAccess } from 'src/app/constants';

@Component({
  selector: 'app-air-freight-actions',
  templateUrl: './air-freight-actions.component.html',
  styleUrls: ['./air-freight-actions.component.scss'],
})
export class AirFreightActionsComponent implements OnInit {
  editAccess: boolean = false;
  download: boolean = false;
  deleteAccess: boolean = false;
  params: any;
  master_id: any;
  master_name: any;
  /*editmode*/
  isEditMode: boolean = false;
  showIcon: boolean;
  accessEdit = false;
  access;
  constructor(public dialog: MatDialog, private router: Router) {}
 
  refresh(): boolean {
    return false;
  }
  agInit(params): void {
    this.access = checkInvAccess();
    this.accessEdit = this.access?.functionalityAccess?.addEditAirfreight || false;

    this.params = params;
    
    this.showIcon = params.showIcon(params); // Call the function
  

  }

  ngOnInit(): void {
  this.access = checkInvAccess();

  }

  checkChanged() {
    console.log(this.params.node.key)
    
    this.params.context.componentParent.userCheckChanged(this.params.node.key);
  }
  deleteChanged() {
    this.params.context.componentParent.userDeleteChanged(this.params.node.rowIndex);
  }
  editData(params: any): void {
    
    console.log(this.params,'params')
    this.checkChanged()
   
  }
  deleteData() {
    this.deleteChanged();
  }
}
